<div class="blank-layout-container justify-content-center">
    <div class="row">
      <div class="col-12 text-center">
        <img src="/assets/images/backgrounds/maintenance.svg" alt="error-bg" />
        <h2 class="auth-title f-w-600">Maintenance Mode!!!</h2>
        <h6 class="f-s-20 f-w-600 m-b-30">Website is Under Construction. Check back later!</h6>
        <a mat-flat-button color="primary" [routerLink]="['/dashboards/dashboard1']">Go back to Home</a>
      </div>
    </div>
  </div>
  